import React from 'react';
import { trackTeaserScroll } from '../../../utils/formAiTeaserAnalytics';
import { safeNum, formatInt } from '../../../utils/gpsFormUtils';
import { FORM_AI_TEASER } from '../../../config';

// Robust scroll — never crash, smooth-scroll the target into view if it exists.
const scrollToId = (id) => {
  try {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  } catch (_) {
    // DOM unavailable (e.g. test env) — ignore.
  }
};

const TextView = ({ breakdown, project, currentUser }) => {
  const respondents = safeNum(breakdown?.current?.respondents);

  const handleScrollToDetail = (e) => {
    e.preventDefault();
    scrollToId('form-detail-table');
  };

  const handleScrollToTeaser = (e) => {
    e.preventDefault();
    trackTeaserScroll({ project, currentUser });
    scrollToId('form-ai-teaser');
  };

  return (
    <div data-testid="explorer-text" className="py-4">
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Question à réponse libre — consultez le détail des réponses ci-dessous.
        {respondents > 0 && (
          <span className="text-gray-500 dark:text-gray-400"> · {formatInt(respondents)} réponses</span>
        )}
      </p>
      <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-medium">
        <a
          href="#form-detail-table"
          onClick={handleScrollToDetail}
          className="text-violet-600 dark:text-violet-400 hover:text-violet-700 dark:hover:text-violet-300 transition-colors"
        >
          Voir le détail des réponses ↓
        </a>
        {FORM_AI_TEASER && (
          <a
            href="#form-ai-teaser"
            onClick={handleScrollToTeaser}
            className="text-violet-600 dark:text-violet-400 hover:text-violet-700 dark:hover:text-violet-300 transition-colors"
          >
            Voir l'Analyse IA ↓
          </a>
        )}
      </div>
    </div>
  );
};

export default TextView;
